export class ProductCapabilityError extends Error {
  readonly status: number;
  readonly productCode: string;
  readonly retryable: boolean;

  constructor(message: string, status: number, productCode: string) {
    super(message);
    this.name = `ProductCapabilityError`;
    this.status = status;
    this.productCode = productCode;
    this.retryable = status === 0 || status >= 500;
  }
}
